import React from 'react';
import { useStyletron } from 'baseui';
import { type SelectOverrides, Select, SIZE } from 'baseui/select';
import { Z_INDEX_LAYERS } from '../../../../constants';
export type TimelineTab = {
  id: string;
  title: string;
};
type PropsT = {
  options: TimelineTab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
};
const getSelectOverrides = (): SelectOverrides => {
  return {
    Root: {
      props: {
        'data-testid': 'annotation-timeline-select'
      }
    },
    DropdownOption: {
      style: ({
        $theme
      }) => ({
        fontSize: $theme.typography.LabelXSmall.fontSize,
        paddingLeft: $theme.sizing.scale400
      })
    },
    DropdownListItem: {
      style: ({
        $theme
      }) => ({
        fontSize: $theme.typography.LabelXSmall.fontSize,
        paddingLeft: $theme.sizing.scale400
      })
    },
    Popover: {
      props: {
        overrides: {
          Body: {
            style: {
              zIndex: Z_INDEX_LAYERS.FIVE
            }
          }
        }
      }
    }
  };
};
export const AnnotationTimelineSelect = ({
  options,
  activeTabId,
  onTabChange
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    width: '100%',
    backgroundColor: theme.colors.backgroundPrimary,
    padding: theme.sizing.scale0,
    paddingTop: theme.sizing.scale100
  })}>
      <Select options={options.map(opt => ({
      label: opt.title,
      id: opt.id
    }))} value={[{
      id: activeTabId
    }]} onChange={params => {
      const propagationMethod = params.value[0]?.label?.toString().toUpperCase();
      propagationMethod && onTabChange(propagationMethod);
    }} size={SIZE.mini} clearable={false} searchable={false} overrides={getSelectOverrides()} />
    </div>;
};